import React, { useState } from 'react';
import { ArticleMarkup } from './articleMarkup';
import './blog.css';
export { safeLink, readableDate } from './articleMarkup';
export function ArticleImage({ src, alt, eager = false }) {
    const [failed, setFailed] = useState(null);
    return src && /^https?:\/\//i.test(src) && failed !== src ? <img src={src} alt={alt || ''} loading={eager ? 'eager' : 'lazy'} decoding="async" onError={() => setFailed(src)} /> : null;
}
export default function Article({ post }) {
    return <ArticleMarkup post={post} ImageComponent={ArticleImage} />;
}
